import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function Flex({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M18.1 21V21.9H19.9V21H18.1ZM4.1 21V21.9H5.9V21H4.1ZM8.25 20.1H7.35V21.9H8.25V20.1ZM15.75 21.9H16.65V20.1H15.75V21.9ZM8.25 19.1C7.75294 19.1 7.35 19.5029 7.35 20C7.35 20.4971 7.75294 20.9 8.25 20.9V19.1ZM15.75 20.9C16.2471 20.9 16.65 20.4971 16.65 20C16.65 19.5029 16.2471 19.1 15.75 19.1V20.9ZM19.9 21V10H18.1V21H19.9ZM19.9 10V7H18.1V10H19.9ZM19.9 7V6H18.1V7H19.9ZM16 2.1H8V3.9H16V2.1ZM4.1 6V21H5.9V6H4.1ZM8 2.1C5.84609 2.1 4.1 3.84609 4.1 6H5.9C5.9 4.8402 6.8402 3.9 8 3.9V2.1ZM19.9 6C19.9 3.84609 18.1539 2.1 16 2.1V3.9C17.1598 3.9 18.1 4.8402 18.1 6H19.9ZM19 7.9H19.7V6.1H19V7.9ZM19 7.2V9.8H20.8V7.2H19ZM19.7 9.1H19V10.9H19.7V9.1ZM19 9.8C19 9.4134 19.3134 9.1 19.7 9.1V10.9C20.3075 10.9 20.8 10.4075 20.8 9.8H19ZM19.7 7.9C19.3134 7.9 19 7.5866 19 7.2H20.8C20.8 6.59249 20.3075 6.1 19.7 6.1V7.9ZM8.25 21.9H15.75V20.1H8.25V21.9ZM8.25 20.9H15.75V19.1H8.25V20.9Z" fill="currentColor" /></Svg>;
}
export default Flex;